import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight, ArrowUp, Sparkles } from "lucide-react";
import { getAuthUrl } from "@/utils/redirectUtils";
import { Link } from "react-router-dom";

const VPGFinalCTA = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section className="py-24 px-4 bg-gradient-to-b from-primary/5 to-background relative overflow-hidden">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-primary/5 rounded-full blur-3xl" />

      <div className="container mx-auto max-w-4xl relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <Sparkles className="h-12 w-12 text-primary mx-auto mb-6" />
          <h2 className="text-3xl md:text-5xl font-bold mb-6">
            Ready to Stand Out in Google Ads?
          </h2>
          <p className="text-lg md:text-xl text-muted-foreground mb-10 max-w-2xl mx-auto leading-relaxed">
            Stop competing with generic ad copy. Generate a custom value
            proposition that makes searchers click your ad instead of your
            competitor's.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
            <Button
              size="lg"
              className="h-14 px-10 text-lg"
              onClick={scrollToTop}
            >
              Generate My Value Proposition <ArrowUp className="ml-2 h-5 w-5" />
            </Button>
            <Button
              variant="outline"
              size="lg"
              className="h-14 px-10 text-lg"
              onClick={() => (window.location.href = getAuthUrl())}
            >
              Start Free Campaign <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </div>

          <p className="text-sm text-muted-foreground mb-12">
            No credit card required. Your first campaign is free.
          </p>

          {/* Internal links for SEO */}
          <div className="flex flex-wrap gap-4 justify-center text-sm">
            <Link to="/features" className="text-primary hover:underline">
              All Features
            </Link>
            <span className="text-muted-foreground">|</span>
            <Link to="/how-it-works" className="text-primary hover:underline">
              How It Works
            </Link>
            <span className="text-muted-foreground">|</span>
            <Link
              to="/keyword-optimisation"
              className="text-primary hover:underline"
            >
              Keyword Optimisation
            </Link>
            <span className="text-muted-foreground">|</span>
            <Link to="/pricing" className="text-primary hover:underline">
              Pricing Plans
            </Link>
            <span className="text-muted-foreground">|</span>
            <Link to="/faqs" className="text-primary hover:underline">
              FAQs
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default VPGFinalCTA;
